import request from '@/utils/request'
export async function home(data) {
    return request({
      url: 'api/home',
      method: 'get',
      data,
    })
  }
export async function gxlanmu(data) {
    return request({
      url: 'api/gxlanmu',
      method: 'get',
      data,
    })
  }
export async function set(data) {
    return request({
      url: 'api/set',
      method: 'get',
      data,
    })
  }
export async function leftlist(data) {
    return request({
      url: 'api/leftlist',
      method: 'post',
      data,
      enableCache: true,
    })
  }
export async function rightlist(data) {
    return request({
      url: 'api/rightlist',
      method: 'post',
      data,
      enableCache: true,
    })
  }
//   专题专栏右边
export async function liebiao(data) {
    return request({
      url: 'api/liebiao',
      method: 'post',
      data,
      enableCache: true,
    })
  }
//   专题专栏--文件下载
export async function downlist(data) {
    return request({
      url: 'api/downlist',
      method: 'post',
      data,
      enableCache: true,
    })
  }
//   公众留言-留言列表
export async function lylist(data) {
    return request({
      url: 'api/lylist',
      method: 'post',
      data,
      enableCache: true,
    })
  }
//   公众留言-留言统计
export async function lytongji(data) {
    return request({
      url: 'api/lytongji',
      method: 'post',
      data,
      enableCache: true,
    })
  }
//   搜索
export async function allsearch(data) {
    return request({
      url: 'api/allsearch',
      method: 'post',
      data,
    })
  }
//   搜索
export async function get_sousuo_content(data) {
    return request({
      url: 'api/get_sousuo_content',
      method: 'post',
      data,
    })
  }
//   文章详情
export async function wdetail(data) {
    return request({
      url: 'api/wdetail',
      method: 'post',
      data,
      enableCache: true,
    })
  }
//  高新区财政（务）预决算----列表
export async function get_juesuan(data) {
    return request({
      url: 'api/get_juesuan',
      method: 'get',
      data,
    })
  }
//  高新区财政（务）预决算----列表---列表
export async function gg_list(data) {
    return request({
      url: 'api/gg_list',
      method: 'post',
      data,
      enableCache: true,
    })
  }
//  文章详情
export async function lydetail(data) {
    return request({
      url: 'api/lydetail',
      method: 'post',
      data,
      enableCache: true,
    })
  }
//  留言提交
export async function liuyan(data) {
    return request({
      url: 'api/liuyan',
      method: 'post',
      data,
    })
  }